"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _bls = require("@chainsafe/bls");
var _crypto = require("crypto");
var _scryptJs = require("scrypt-js");
var _ethereumjsUtil = require("ethereumjs-util");
var _uuid = require("uuid");
var _utils = require("./utils");
const generate = async function (privateKey, password) {
  let params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  let path = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  password = (0, _utils.normalizePassword)(password);
  const v4Defaults = {
    cipher: 'aes-128-ctr',
    kdf: 'scrypt',
    salt: (0, _crypto.randomBytes)(32),
    iv: (0, _crypto.randomBytes)(16),
    dklen: 32,
    c: 262144,
    n: 262144,
    r: 8,
    p: 1,
    uuid: (0, _crypto.randomBytes)(16)
  };
  Object.assign(v4Defaults, params);
  let derivedKey, kdfParams;
  if (v4Defaults.kdf === _utils.KDFFunctions.PBKDF) {
    kdfParams = (0, _utils.kdfParamsForPBKDF)(v4Defaults);
    derivedKey = (0, _crypto.pbkdf2Sync)(Buffer.from(password), kdfParams.salt, kdfParams.c, kdfParams.dklen, 'sha256');
  } else {
    kdfParams = (0, _utils.kdfParamsForScrypt)(v4Defaults);
    derivedKey = await (0, _scryptJs.scrypt)(Buffer.from(password), kdfParams.salt, kdfParams.n, kdfParams.r, kdfParams.p, kdfParams.dklen);
    derivedKey = Buffer.from(derivedKey);
  }
  const cipher = (0, _crypto.createCipheriv)(v4Defaults.cipher, derivedKey.slice(0, 16), v4Defaults.iv);
  const ciphertext = (0, _utils.runCipherBuffer)(cipher, privateKey);
  await (0, _bls.init)('herumi');
  return {
    crypto: {
      kdf: {
        function: v4Defaults.kdf,
        params: {
          ...kdfParams,
          salt: kdfParams.salt.toString('hex')
        },
        message: ''
      },
      checksum: {
        function: 'sha256',
        params: {},
        message: (0, _ethereumjsUtil.sha256)(Buffer.concat([derivedKey.slice(16), ciphertext])).toString('hex')
      },
      cipher: {
        function: v4Defaults.cipher,
        params: {
          iv: v4Defaults.iv.toString('hex')
        },
        message: ciphertext.toString('hex')
      }
    },
    description: '',
    pubkey: Buffer.from(_bls.SecretKey.fromBytes(privateKey).toPublicKey().toBytes()).toString('hex'),
    path: path,
    uuid: (0, _uuid.v4)({
      random: v4Defaults.uuid
    }),
    version: 4
  };
};
var _default = generate;
exports.default = _default;